import { CURRENT_PATHNAME_STORAGE_KEY, PREVIOUS_PATHNAME_STORAGE_KEY } from "@/lib/constants";
import { getLocalCurrentPathname, getLocalPreviousPathname } from "@/lib/utils/storage";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const isDev = process.env.NODE_ENV === "development";

const useTrackPreviousPathname = () => {
  const location = useLocation();
  const initialized = useRef(false);
  const pathnameUpdated = useRef(false);

  useEffect(() => {
    if (isDev && initialized.current) return; // do this to avoid bugs on Strict Mode (during development)

    const localPreviousPathname = sessionStorage.getItem(PREVIOUS_PATHNAME_STORAGE_KEY);
    const localCurrentPathname = sessionStorage.getItem(CURRENT_PATHNAME_STORAGE_KEY);

    if (!localPreviousPathname) {
      sessionStorage.setItem(PREVIOUS_PATHNAME_STORAGE_KEY, "/");
    }

    if (!localCurrentPathname) {
      sessionStorage.setItem(CURRENT_PATHNAME_STORAGE_KEY, "/");
    }

    initialized.current = true;
  }, []);

  useEffect(() => {
    if (isDev && pathnameUpdated.current) {
      pathnameUpdated.current = false;
      return;
    }

    const localPreviousPathname = getLocalPreviousPathname();
    const localCurrentPathname = getLocalCurrentPathname();
    const newPath = location.pathname;

    if (localPreviousPathname !== localCurrentPathname) {
      const pathname = localCurrentPathname.replace(/(.*)\/x\/[^/]+\/(.*)/, "$1/$2");
      sessionStorage.setItem(PREVIOUS_PATHNAME_STORAGE_KEY, pathname);
    }
    sessionStorage.setItem(CURRENT_PATHNAME_STORAGE_KEY, newPath);

    if (isDev) {
      pathnameUpdated.current = true;
    }
  }, [location.pathname]);
};

export default useTrackPreviousPathname;
